'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    //手风琴效果
    accordion: {
      type: Boolean,
      default: false
    },
    activeNames: {
      type: [Number, String],
      default: -1
    }
  },
  provide: function provide() {
    return {
      _activeData: this.activeData
    };
  },
  data: function data() {
    return {
      activeData: { _activeName: -1, accordion: this.accordion }
    };
  },

  computed: {},
  created: function created() {},

  methods: {
    //接收子组件点击事件
    collapseClick: function collapseClick(value) {
      if (this.accordion) {
        this.activeData._activeName = this.activeData._activeName == value.name ? 0 : value.name;
        this.$emit('change', { name: this.activeData._activeName });
      } else {
        //从数组中去除
        if (value.collapsed) {
          if (this.activeNames.length) {
            var currIndex = this.activeNames.findIndex(function (x) {
              return x == value.name;
            });
            this.activeNames.splice(currIndex, 1);
          }
        } else {
          this.activeNames.push(Number(value.name));
          this.activeNames.sort(function (a, b) {
            return a - b;
          });
        }
        this.$emit('change', { name: this.activeNames });
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-collapse/index.vue
// module id = 320
// module chunks = 0 1